module.exports = __webpack_public_path__ + "05_face.6ff32530.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/05_face.png
// module id = 0TQP
// module chunks = 0